import type { ComponentsOverrides, Theme } from '@mui/material'

const styleOverrides: ComponentsOverrides<Theme>['MuiTextField'] = {
  root: ({ theme }) => ({
    backgroundColor: theme.palette.background.base,
    borderRadius: theme.spacing(1),
    '&.Mui-disabled': {
      opacity: 0.5,
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[400],
      },
    },

    '& > label': {
      '&.Mui-focused': {
        color: theme.palette.secondary.main,
      },
    },

    '& .MuiOutlinedInput-root': {
      '&:hover': {
        backgroundColor: theme.palette.text.hover,
      },

      '& fieldset': {
        borderColor: theme.palette.grey[400],
      },

      '&.Mui-focused fieldset': {
        borderColor: theme.palette.secondary.main,
      },

      '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },

      '&.Mui-error.Mui-focused fieldset': {
        borderColor: theme.palette.error.main,
      },

      '&.Mui-focused .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
  }),
}

const MuiTextField = {
  styleOverrides,
}

export default MuiTextField
